import { Button, PageHeader } from "antd";
import { observer } from "mobx-react";
import { useEffect, useState } from "react";
import BreadcrumbComponent from "../../../component/BreadcrumbComponent";
import RecordPerPage from "../../../component/RecordPerPage";
import { BreadcrumbConfig } from "../../../config/BreadcrumbConfig";
import useStore from "../../../store";
import ListComponent from "./component/ListComponent";
import EditComponent from "./component/EditComponent";
import ViewComponent from "./component/ViewComponent";
import RollbackComponent from "./component/RollbackComponent";
import TransferComponent from "./component/TransferComponent";
import ChangeVehicleType from "./component/ChangeVehicleTypeComponent"

const InStock = observer((props) => {
	const [editModal, setEditModal] = useState(false);
	const [viewModal, setViewModal] = useState(false);
	const [rollbackModal, setRollbackModal] = useState(false);
	const [transferModal, setTransferModal] = useState(false);
	const [changeVehicleTypeModal, setChangeVehicleTypeModal] = useState(false);
	const {
		InStockStore: {
			getList,
			setEditValues,
			setViewValues,
			setRollbackValues,
			setTransferValues,
			setPageSize,
			per_page,
		},
		AUTH
	} = useStore();

	// Open & Close  form for edit State
	const openEditModal = (data) => {
		setEditValues(data);
		setEditModal(true);
	};
	const closeEditModal = () => setEditModal(false);

	// Open & Close  form for edit State
	const openViewModal = (data) => {
		setViewValues(data);
		setViewModal(true);
	};
	const closeViewModal = () => setViewModal(false);

	// Open & Close  form for rollback stock
	const openRollbackModal = (data) => {
		setRollbackValues(data);
		setRollbackModal(true);
	};
	const closeRollbackModal = () => setRollbackModal(false);

	// Open & Close  form for transfer stock
	const openTransferModal = (data) => {
		setTransferValues(data);
		setTransferModal(true);
	};
	const closeTransferModal = () => setTransferModal(false);

	// Open & Close  form for add new State
	const openChangeVehicleTypeModal = () => setChangeVehicleTypeModal(true);
	const closeChangeVehicleTypeModal = () => setChangeVehicleTypeModal(false);

	useEffect(() => {
		getList();
	}, [getList]);

	return (
		<PageHeader
			title={BreadcrumbConfig.InStock.title}
			className="tableAreaSec"
			extra={<BreadcrumbComponent items={BreadcrumbConfig.InStock.path} />}
		>
			<div className="listCountNew">
			{(AUTH.checkPrivileges("#2035#") || AUTH.checkPrivileges("#2060#")) && (
					<Button key="1" onClick={openChangeVehicleTypeModal}>
						Change Vehicle Type
					</Button>
				)}
				<RecordPerPage
					key="2"
					style={{ width: "150px" }}
					defaultValue={per_page + " per page"}
					onChange={setPageSize}
				/>
			</div>
			<EditComponent visible={editModal} close={closeEditModal} />
			<ViewComponent visible={viewModal} close={closeViewModal} />
			<RollbackComponent visible={rollbackModal} close={closeRollbackModal} />
			<TransferComponent visible={transferModal} close={closeTransferModal} />
			<ChangeVehicleType  visible={changeVehicleTypeModal} close={closeChangeVehicleTypeModal}/>
			<ListComponent
				openEditModal={openEditModal}
				openViewModal={openViewModal}
				openRollbackModal={openRollbackModal}
				openTransferModal={openTransferModal}
				openChangeVehicleTypeModal={openChangeVehicleTypeModal}
			/>
		</PageHeader>
	);
});

export default InStock;
